// extracted by mini-css-extract-plugin
module.exports = {"navigation":"footer-module--navigation--xsrJ1","navigationItem":"footer-module--navigationItem--3yxcd","tw":"footer-module--tw--21eA0"};